export default __webpack_public_path__ + "static/time-icon-4cb257df7a1e8de89b0eab91e5ca3477.png";